module.exports = __webpack_public_path__ + "c7a28eae17f4cc25a4bfeabd69e2e981.svg";